<template>
    <div class="form-group focused searchListBox" :class="{'has-error':errors[title]!=undefined,'focused':modelValue!='' && modelValue!=null?true:false,'buttons':buttons==true}">
        <div class="search" v-if="$slots.search">
        <slot name="search"></slot>
        </div>
        <Field as="select" size="7" v-bind="$attrs" :id="uid" :name="title" class="form-control" :class="{'parsley-error':errors[title]!=undefined}" v-model="model" @input="$emit('update:modelValue',$event.target.value)" :rules="rules" v-if="$slots.input">
            <slot name="input"></slot>
        </Field>
        <div v-if="$slots.inputCustom" :class="{'parsley-error':errors[title]!=undefined}" v-bind="$attrs" class="customInput">
            <ul>
                <slot name="inputCustom"></slot>
            </ul>
            <Field type="text" v-bind="$attrs" :id="uid" :name="title" class="form-control" v-model="model" @input="$emit('update:modelValue',$event.target.value)" :rules="rules"></Field>
        </div>

		<label class="control-label" :for="uid" :class="{'disabled':$attrs.disabled}" v-if="isTitle!=false">{{title}} </label>
        <slot name="buttons"></slot>
        <ErrorMessage as="span" class="form-control-feedback small" :name="title" />
    </div>  
</template>
<script>
    export default {
        name:"selectBox",
        props:["errors","title","isTitle","modelValue","rules","buttons"],
        // components:{searchSelectBox},
        data(){
            return{
                uid:this.$uniqueid(),
                model:this.modelValue
            }
        },
        watch:{
            modelValue(){
                this.model=this.modelValue;
            }
        },
        methods:{
            log(val){
                console.log(val);
            }
        }
    }
</script>
<style scoped>
</style>

